/**
 * MGT Relaunch PDP Template
 * Entry point for all mgt-pdp-* sections. One bundle per template.
 */
import initMgtHero from '../components/mgt-hero.js';
import initMgtQuiz from '../components/mgt-quiz.js';
import initMgtPathways from '../components/mgt-pathways.js';
import initMgtSymptomBand from '../components/mgt-symptom-band.js';

function initMgtRelaunch() {
  initMgtHero();
  initMgtQuiz();
  initMgtPathways();
  initMgtSymptomBand();
}

document.addEventListener('DOMContentLoaded', initMgtRelaunch);
